import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './chatApi';

export const knowledgeBaseApi = createApi({
    reducerPath: 'knowledgeBaseApi',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['FileConfig', 'DbConfig', 'AiChatSettings'],
    endpoints: (builder) => ({
        // File Configs
        getFileConfigs: builder.query({
            query: () => '/file_configs',
            providesTags: ['FileConfig']
        }),
        createFileConfig: builder.mutation({
            query: (fileConfig) => ({
                url: '/file_configs',
                method: 'POST',
                body: fileConfig,
                headers: {}
            }),
            invalidatesTags: ['FileConfig']
        }),
        deleteFileConfig: builder.mutation({
            query: (body) => ({
                url: `/file_configs/delete`,
                method: 'POST',
                body: body
            }),
            invalidatesTags: ['FileConfig']
        }),
        // Database Configs
        getDbConfigs: builder.query({
            query: () => '/db_configs',
            providesTags: ['DbConfig']
        }),
        createDbConfig: builder.mutation({
            query: (configData) => ({
                url: '/db_configs',
                method: 'POST',
                body: configData
            }),
            invalidatesTags: ['DbConfig']
        }),
        deleteDbConfig: builder.mutation({
            query: (id) => ({
                url: `/db_configs/${id} `,
                method: 'DELETE'
            }),
            invalidatesTags: ['DbConfig']
        }),
        // AI Chat Settings
        getAiChatSettings: builder.query({
            query: () => '/ai_chat_settings',
            providesTags: ['AiChatSettings']
        }),
        saveAiChatSettings: builder.mutation({
            query: (settings) => ({
                url: '/ai_chat_settings',
                method: 'POST',
                body: settings
            }),
            invalidatesTags: ['AiChatSettings']
        })
    })
});

export const {
    useGetFileConfigsQuery,
    useCreateFileConfigMutation,
    useDeleteFileConfigMutation,
    useGetDbConfigsQuery,
    useCreateDbConfigMutation,
    useDeleteDbConfigMutation,
    useGetAiChatSettingsQuery,
    useSaveAiChatSettingsMutation
} = knowledgeBaseApi;
